import React, {useEffect, useState} from 'react';
import './OTPLoginBlock.scss';
import ProgressBar from '../../Shared/ProgressBar/progressBar';
import {loginStep, lobbySelection, rolesLogin, rolesKeys} from './Assets/variables';
import {isMobileOnly as isMobile, isTablet, withOrientationChange} from 'react-device-detect';
import Header from './Assets/header';
import PhoneInsert from './Stages/phoneInsert';
import PhoneInsertFullLogin from './Stages/phoneInsertFullLogin';
import GenericParamsInsert from './Stages/genericParamsInsert';
import TalkmanScreen from './Stages/talkmanScreen';

import {connect} from 'react-redux';
import OTPInsert from './Stages/otpInsert';
import IdInsert from './Stages/idInsert';
import CodeInsert from './Stages/codeInsert';
import ChooseLobby from './Stages/chooseLobby';
import ChoosePrivate from './Stages/choosePrivate';
import ErrorScreen from './Stages/errorScreen';
import NoPrimaryScreen from './Stages/noPrimaryScreen';
import GeneralErrorScreen from './Stages/generalerrorScreen';
import {buildUrlAndNavigate} from '../../../utilities/StringHelpers/StringHelpers';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {otpOrigin} from '../OTPLoginBlock/Assets/variables';
import {
  createOtpLoginStep1,
  createOtpLoginStep02,
  resetLoginData,
  createOtpLoginStep3,
  resendOtpStep1,
  saveDumbLogin,
  resetAuth,
  setRedirectUrl,
  setLoginStage,
  saveToHistory,
  setContinueToSite,
  setOtpError,
  setRestrictedCodeError,
  createFullLoginStep1,
  changeContactLogin,
  setLoginTemplate,
  forceExtendedOtp,
  reAuthenticateThunk,
  clearHistory
} from '../../../utilities/authentication/authenticationSlice';
import {setTabIndex} from 'app/Components/Block/HeaderMainBlock/HeaderBlockSlice/';
import Config from '../../../Config';
import {report, getReportParams} from '../../../middleware/report';
import AuthenticationProvider from '../../../utilities/authentication/authenticationProvider';
import MailOTPInsert from './Stages/mailOtpInsert';
import FourDigitEntry from './Stages/fourDigitEntry';
import PaypalEmailEntry from './Stages/paypalEmailEntry';
import Loader from '../../Shared/Loader/LocalLoader';
import { LoginFieldsByType } from './constant';
const OTPLogin = (props) => {
  const isFullLoginProcess = props.iContent?.isFullLogin?.value;

  const [cameFromPage, setCameFromPage] = useState(
    (props.authentication?.loginData?.isOtpAuthenticated || props.authentication?.loginData?.isOtpExtendedAuthenticated) &&
      !isFullLoginProcess,
  );

  const [lobbyToSend, setLobby] = useState(lobbySelection.PRIVATE);
  const [ticketId, setTicket] = useState(null);
  const [phoneUsed, setPhone] = useState(null);
  const [mailUsed, setMail] = useState(null);
  const [isPhoneChange, setPhoneChange] = useState(null);
  const [digitsUser, setDigits] = useState(null);
  const [contactCli, setContactCli] = useState(null);
  const [consumerIds, setConsumerIds] = useState(null);
  const [contactId, setContactId] = useState(null);
  const [isNotOut, setNotOut] = useState(true);
  const [isLoading, setLoading] = useState(false);
  const [genericValues, setGenericValues] = useState(null);
  const searchParams = new URLSearchParams(window.location.search);
  const loginType = searchParams.get('loginType')? searchParams.get('loginType') : '';
  const isGenericLogin = Boolean(loginType && LoginFieldsByType[loginType]);

  const [templateStyle, setTemplateStyle] = useState({
    title: null,
    secondaryText: null,
    iconUrl: null,
    backgroundUrl: null,
  });
  const [codeNeeded, setCode] = useState(false);
  const [idUsed, setId] = useState('');
  const [moreThanOneId, setMoreId] = useState(false);
  const [showTerms, setTerms] = useState(false);
  const [isResetProcess, setResetProcess] = useState(false);
  const [tooManyCodes, setTooManyCodes] = useState(false);
  const [isOtherContact, setOtherContact] = useState(false);
  const [isVoiceOtp, setVoice] = useState(false);

  const setBusinessTab = async (isBusiness = 1) => {
    await props.setTabIndex(isBusiness);
  };

  const determineLoginType = (loginType) => {
    const isFull = loginType == rolesKeys.OTPCUSTOMER;
    const isOtp = loginType == rolesKeys.OTPSUBSCRIBER;
    const isExtended = loginType == rolesKeys.OTPEXTENDED;
    return {
      isFullAuthenticated: isFull,
      isOtpAuthenticated: isOtp,
      isOtpExtendedAuthenticated: isExtended,
    };
  };

  const finishExtended = (isComplicit = false) => {
    if (isComplicit && props.authentication.redirectUrl) {
      goToPage(props.authentication.redirectUrl);
    } else {
      goToPage(Config.lobbyUrl);
    }
  };

  const moveStage = (stage) => {
    setNotOut(true);
    setLoading(false);
    window.scrollTo(0, 0);
    props.setLoginStage(stage);
  };

  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    //check if need to redirect
    window.addEventListener('hashchange', setStageOnBack);
    window.addEventListener('visibilitychange', onVisibilityChange);

    const loginDataFromStorage = AuthenticationProvider.getLoginData();

   

    if (cameFromPage) {
      window.location.hash = '';
      if (
        (loginDataFromStorage?.isOtpAuthenticated ||
          loginDataFromStorage?.isOtpExtendedAuthenticated ||
          loginDataFromStorage?.isFullAuthenticated) &&
        !props.loginData?.isOtpAuthenticated &&
        !props.loginData?.isFullAuthenticated &&
        !props.loginData?.isOtpExtendedAuthenticated
      ) {
        props.reAuthenticateThunk(props.context.getCurrentPath());
      }
    }
    const redirectURLFromLogin = searchParams.get('returnUrl') || props.authentication.redirectUrl;
    const redirectFromLogin = redirectURLFromLogin ? decodeURIComponent(redirectURLFromLogin) : null;

    var authData = props.authentication.loginData;
    if(isGenericLogin && (authData?.isFullAuthenticated || authData?.isOtpAuthenticated || authData?.isOtpExtendedAuthenticated)) {
        props.resetLoginData(); 
        AuthenticationProvider.clearAuthenticationData();
        return;
    }
    if (authData?.isFullAuthenticated) {
      if (redirectFromLogin) {
        goToPage(redirectFromLogin);
      } else {
        const isPrivateContact = props.authentication.loginData.userDetails.RoleList.some((r) => r.includes(rolesKeys.PRIVATE));
        const isBusinessContact = props.authentication.loginData.userDetails.RoleList.some((r) => r.includes(rolesKeys.BUSINESS));
        const isCellular = props.authentication.loginData.userDetails.RoleList.includes(rolesKeys.SUBSCRIBER);
        if (isPrivateContact || isCellular) {
          if (isBusinessContact) {
            moveStage(loginStep.SELECTLOBBY);
          } else {
            setBusinessTab(0);
            goToPage(Config.lobbyUrl);
          }
        } else if (isBusinessContact) {
          setBusinessTab(1);
          goToPage(Config.businessLobbyUrl);
        }
      }
    } else {
      let reportParams = {};
      reportParams = getReportParams();
      reportParams.area = 'SelfCare';
      reportParams.subArea = 'NEW_OTP';
      reportParams.channel = 'WebsitePrivate';
      reportParams.actionType = 'Entered New Otp';
      reportParams.status = 'Ongoing';
      reportParams.messageText = 'Entered New Otp';
      reportParams.param1 = redirectFromLogin ? redirectFromLogin : '';
      report(reportParams);

      setStageOnBack();
    }

    if (redirectFromLogin) {
      props.setRedirectUrl(redirectFromLogin);
    }

    const templateArr = props.iContent?.templates?.expandedValue?.map((t) => {
      return {
        title: t.title?.value && t.title?.value != '' ? t.title?.value : null,
        secondaryText: t.extraText?.value && t.extraText?.value != '' ? t.extraText?.value : null,
        key: t.id?.value,
        iconUrl: t.iconUrl?.value && t.iconUrl?.value != null ? Config.epiBaseUrl + t.iconUrl?.value : null,
        backgroundUrl:
          t.mobileBackground?.value || t.desktopBackground?.value
            ? isMobile
              ? t.mobileBackground?.value && t.mobileBackground?.value != null
                ? Config.epiBaseUrl + t.mobileBackground?.value
                : null
              : t.desktopBackground?.value && t.desktopBackground?.value != null
              ? Config.epiBaseUrl + t.desktopBackground?.value
              : null
            : null,

        relatedPages: t.relatedPages?.expandedValue,
      };
    });
    const templateFromStorage = searchParams.get('loginTemplate') || props.authentication.loginTemplate;
    props.setLoginTemplate(templateFromStorage);
    if (templateFromStorage && templateFromStorage != '' && templateFromStorage != 'null' && templateFromStorage != 'undefined') {
      const templateObj = templateArr?.find((t) => t.key == templateFromStorage);
      console.log('found template: object =>', templateObj);
      if (templateObj) {
        const styleState = {...templateStyle};
        styleState.title = templateObj.title;
        styleState.secondaryText = templateObj.secondaryText;
        styleState.iconUrl = templateObj.iconUrl;
        styleState.backgroundUrl = templateObj.backgroundUrl;
        setTemplateStyle(styleState);
      }
    } else if (redirectFromLogin) {
      let templatesForPage = templateArr?.find((t) =>
        t.relatedPages?.find((p) => p.url == redirectFromLogin || p.url == redirectFromLogin + '/'),
      );
      if (templatesForPage) {
        const styleState = {...templateStyle};
        styleState.title = templatesForPage.title;
        styleState.secondaryText = templatesForPage.secondaryText;
        styleState.iconUrl = templatesForPage.iconUrl;
        styleState.backgroundUrl = templatesForPage.backgroundUrl;
        setTemplateStyle(styleState);
      }
    }

    return () => {
      //const loginData = AuthenticationProvider.getLoginData();
      // if (!loginData?.shouldContinueToSite) {
      //   props.resetLoginData(); //todo - keep resetauth
      //   AuthenticationProvider.clearAuthenticationData();
      // }
      props.forceExtendedOtp(false);
      window.removeEventListener('hashchange', setStageOnBack);
      window.removeEventListener('visibilitychange', onVisibilityChange);
      props.hideAppLoader();
      setLoading(false);
      props.clearHistory();
    };
  }, []);

  const resetAndGoToPhone = () => {
    resetStep2();
    AuthenticationProvider.clearAuthenticationData();
    moveStage(loginStep.PHONE);
    setLobby(lobbySelection.PRIVATE);
    setTicket(null);
    setPhone(null);
    setMail(null);
    setCode(false);
    setId('');
    setMoreId(false);
    setTerms(false);
    props.setOtpError(null);
    props.setRestrictedCodeError(null);
    setContactCli(null);
    setConsumerIds(null);
    window.location.hash = '';
  };

  const setStageOnBack = () => {
    switch (window.location.hash.replaceAll('#', '')) {
      case loginStep.PHONE:
        resetAndGoToPhone();
        break;
      case loginStep.OTP:
        if (ticketId == null || ticketId == '') {
          resetAndGoToPhone();
        } else {
          moveStage(loginStep.OTP);
        }
        break;
      case loginStep.ID:
        moveStage(loginStep.ID);
        break;
      case loginStep.CODE:
        moveStage(loginStep.CODE);
        break;
      case loginStep.DIGITS:
        moveStage(loginStep.DIGITS);
        break;
      case loginStep.PAYPAL_EMAIL:
        moveStage(loginStep.PAYPAL_EMAIL);
        break;
      case loginStep.SELECTLOBBY:
        moveStage(loginStep.SELECTLOBBY);
        break;
      case loginStep.ERROR:
        resetStep2();
        AuthenticationProvider.clearAuthenticationData();
        moveStage(loginStep.ERROR);
        break;
      case loginStep.GENERALERROR:
        resetStep2();
        AuthenticationProvider.clearAuthenticationData();
        moveStage(loginStep.GENERALERROR);
        break;
      default:
        moveStage(cameFromPage ? loginStep.ID : loginStep.PHONE);
        break;
    }
  };

  const renderProgressBar = () => {
    let points = [20, 40, 60, 80, 100];
    switch (props.loginStage) {
      case loginStep.ERROR:
      case loginStep.GENERALERROR:
      case loginStep.PHONE:
        return <ProgressBar points={points} percent={'0'} />;
      case loginStep.OTP:
        return <ProgressBar points={points} percent={'20'} />;
      case loginStep.ID:
        return <ProgressBar points={points} percent={'40'} />;
      case loginStep.CODE:
        return <ProgressBar points={points} percent={'60'} />;
      case loginStep.DIGITS:
      case loginStep.PAYPAL_EMAIL:
        return <ProgressBar points={points} percent={'60'} />;
      case loginStep.SELECTLOBBY:
      case loginStep.SELECTPRIVATE:
        return <ProgressBar points={points} percent={'80'} />;
      default:
        return null;
    }
  };

  const sendOtpAgain = async (isText) => {
    setLoading(true);
    const newOtp = await props.resendOtpStep1({phoneNumber: phoneUsed, isText: isText, guid: ticketId});
    setLoading(false);
    return {isSent: newOtp.payload?.Body?.isSuccess, isShowPopup: newOtp.payload?.Body?.extra?.isBlockShowPopup};
  };

  const getDomain = (url) => {
    url = url.replace(/(https?:\/\/)?(www.)?/i, '');

    url = url.split('.');

    url = url.slice(url.length - 2).join('.');

    if (url.indexOf('/') !== -1) {
      return url.split('/')[0];
    }

    return url;
  };

  const isSiteDomain = (url) => {
    const urlDomain = getDomain(url.replace('https://', '').replace('http://', ''));

    return url.startsWith('/') || (urlDomain == getDomain(Config.staticWebSiteUrl) && urlDomain != '');
  };
  const goToPage = async (pageLink, hardNavigate = false) => {
    if (isFullLoginProcess) {
      let reportParams = {};
      reportParams = getReportParams();
      reportParams.area = 'SelfCare';
      reportParams.channel = 'WebsitePrivate';
      reportParams.status = 'Ongoing';

      reportParams.subArea = 'Login';
      reportParams.actionType = 'Entered Full Login';
      reportParams.messageText = 'Entered Full Login';
      reportParams.param1 = 'Return url: ' + props.authentication.redirectUrl;
      reportParams.idNumber = idUsed;
      reportParams.subscriber = phoneUsed;
      report(reportParams);
    }

    setNotOut(true);
    props.setRedirectUrl(null);
    props.setContinueToSite(true);
    props.setLoginTemplate('');
    props.forceExtendedOtp(false);

    if (hardNavigate) {
      let path = pageLink || '';
      path = decodeURIComponent(path);
      window.location.replace(`${Config.staticWebSiteUrl}${path}`);
      return;
    }

    await buildUrlAndNavigate(pageLink, true);
  };

  const resetStep2 = () => {
    setNotOut(true);
    props.setRedirectUrl(null);
    props.setLoginTemplate('');
    props.forceExtendedOtp(false);
  };

  const OtpStep2Connect = async (val, secVal, fields) => {
    setNotOut(false);
    const res = await props.createOtpLoginStep02({
      guid: ticketId,
      otpCode: val,
      phoneNumber: phoneUsed,
      restrictCode: secVal,
      termsAccepted: showTerms,
      otpOrigin: otpOrigin.LOGIN,
      originProcess: props.authentication.redirectUrl,
      loginType: loginType ? loginType : '',
      genericFields: fields ? fields : null,
    });
    setNotOut(true);
    return res.payload;
  };

  const OtpStep2ConnectFull = async (val, secVal) => {
    setNotOut(false);
    const res = await props.createOtpLoginStep02({
      guid: ticketId,
      otpCode: val,
      phoneNumber: isPhoneChange ? mailUsed : phoneUsed,
      restrictCode: secVal,
      termsAccepted: showTerms,
      loginType: loginType ? loginType : rolesKeys.NEWCREDENTIALS,
      idNumber: idUsed,
      originProcess: props.authentication.redirectUrl,
      customerEmail: isPhoneChange ? null : mailUsed,
    });
    setNotOut(true);
    return res.payload;
  };

  const ChangeContact = async (val, secVal, shouldChange) => {
    setLoading(true);
    const res = await props.changeContactLogin({
      guid: ticketId,
      otpCode: val,
      phoneNumber: phoneUsed,
      restrictCode: secVal,
      idNumber: idUsed,
      changeContact: shouldChange,
      paymentDigits: digitsUser,
      contactCli: contactCli,
      consumerIds: consumerIds,
      contactId: contactId,
    });
    const resOtp = res.payload;
    if (resOtp.isSuccess) {
      if (props.authentication.redirectUrl) {
        const urlToRedirect = props.authentication.redirectUrl;
        goToPage(urlToRedirect);
      } else {
        if (props.isBusinessTab && props.isBusinessTab == 1) {
          setBusinessTab(1);
          goToPage(Config.businessLobbyUrl);
        } else {
          setBusinessTab(0);
          goToPage(Config.lobbyUrl);
        }
      }
    } else {
      let codeGiven = parseInt(resOtp.codeError);
      if (codeGiven == 58 || codeGiven == 42 || codeGiven == 99 || codeGiven == 39) {
        props.setContinueToSite(false);
        moveStage(loginStep.ERROR);
        await props.saveToHistory(loginStep.ERROR);
      } else if (codeGiven == 750) {
        props.setContinueToSite(false);
        moveStage(loginStep.GENERALERROR);
        await props.saveToHistory(loginStep.GENERALERROR);
      } else if (codeGiven == 1003) {
        setLoading(false);

        return {isSuccess: false, codeError: 1003};
      } else {
        setLoading(false);

        return resOtp;
      }
    }

    return res.payload;
  };

  const OtpStep3Connect = async (obj) => {
    const resLogin = await props.createOtpLoginStep3(obj);
    if (resLogin.payload.isSuccess && resLogin.payload.needsCode) {
      setCode(true);
    } else {
      setCode(false);
    }
    return resLogin.payload;
  };

   

  async function handleOtpSend2 (val, secVal) {
    let resOtp =null;
    if(isGenericLogin){
        resOtp = await OtpStep2Connect(val, secVal, genericValues);

    }else{
       resOtp = await OtpStep2Connect(val, secVal);
    }
    const isSuccess = resOtp.isSuccess;
    if (isSuccess) {
      resOtp = resOtp.loginData;
      if (resOtp.isOtpAuthenticated || resOtp.isOtpExtendedAuthenticated) {
        //if the otp is correct
        const isPrivateContact = resOtp.userDetails.RoleList.some(
          (r) => r.includes(rolesKeys.PRIVATE) && !r.includes(rolesKeys.OTHERPRIVATE),
        );

        const isOtherPrivateContact = resOtp.userDetails.LoginData?.NumUnderUser != null && resOtp.userDetails.LoginData?.NumUnderUser > 0;
        setOtherContact(isOtherPrivateContact);
        //const isOtherPrivateContact = resOtp.userDetails.PrimaryPhoneIdList?.PrimaryPhoneId?.length > 0; //old convention using the array
        const isBusinessContact = resOtp.userDetails.RoleList.some((r) => r.includes(rolesKeys.BUSINESS));
        const isCellular = resOtp.userDetails.RoleList.some((r) => r.includes(rolesKeys.SUBSCRIBER));
        const multipleIds =
          resOtp.userDetails.LoginData?.NumUnderUser != null &&
          (resOtp.userDetails.LoginData?.NumUnderUser > 1 || (isPrivateContact && isOtherPrivateContact));
        setTooManyCodes(resOtp.userDetails.LoginData?.HasTooManyAccountPassword);
        //const multipleIds = resOtp.userDetails.PrimaryPhoneIdList?.PrimaryPhoneId?.length > 1 || (isPrivateContact && isOtherPrivateContact); ////old convention using the array
        setMoreId(multipleIds);
        if (isBusinessContact) {
          //if client is business contact

          if ((isPrivateContact || isCellular || isOtherPrivateContact) && !resOtp.userDetails.LoginData?.IsFullFinance) {
            //if client is also private contact
            props.setContinueToSite(false);
            moveStage(loginStep.SELECTLOBBY); //then it will send to lobby selection
            await props.saveToHistory(loginStep.SELECTLOBBY);
          } else {
            props.setContinueToSite(false);
            setLobby(lobbySelection.BUSINESS);
            setBusinessTab(1);

            moveStage(loginStep.ID); //refers to id insertion which lets him proceed to relevant lobby
            await props.saveToHistory(loginStep.ID);
          }
        } else if (isPrivateContact || isOtherPrivateContact) {
          if (!multipleIds && tooManyCodes) {
            props.setContinueToSite(false);
            moveStage(loginStep.GENERALERROR);
            await props.saveToHistory(loginStep.GENERALERROR);
          } else {
            //client is private contact
            setLobby(lobbySelection.PRIVATE);
            setBusinessTab(0);

            if (!isCellular) {
              if (multipleIds) {
                props.setContinueToSite(false);
                moveStage(loginStep.ID);
                await props.saveToHistory(loginStep.ID);
              } else {
                if (props.authentication.forceExtended && !resOtp.isOtpExtendedAuthenticated) {
                  setLoading(false);
                  return {isSuccess: true, shouldExtend: true};
                } else {
                  if (props.authentication.redirectUrl) {
                    const urlToRedirect = props.authentication.redirectUrl;
                    goToPage(urlToRedirect);
                  } else {
                    goToPage(Config.lobbyUrl);
                  }
                }
              }
            } else if (isPrivateContact) {
              if (multipleIds) {
                props.setContinueToSite(false);
                moveStage(loginStep.ID);
                await props.saveToHistory(loginStep.ID);
              } else {
                if (props.authentication.forceExtended && !resOtp.isOtpExtendedAuthenticated) {
                  setLoading(false);
                  return {isSuccess: true, shouldExtend: true};
                } else {
                  if (props.authentication.redirectUrl) {
                    const urlToRedirect = props.authentication.redirectUrl;
                    goToPage(urlToRedirect);
                  } else {
                    goToPage(Config.lobbyUrl);
                  }
                }
              }
            } else {
              props.setContinueToSite(false);
              moveStage(loginStep.SELECTPRIVATE);
              await props.saveToHistory(loginStep.SELECTPRIVATE);
            }
          }
        } else {
          if (tooManyCodes) {
            props.setContinueToSite(false);
            moveStage(loginStep.GENERALERROR);
            await props.saveToHistory(loginStep.GENERALERROR);
          } else {
            if (props.authentication.forceExtended && !resOtp.isOtpExtendedAuthenticated) {
              setLoading(false);
              return {isSuccess: true, shouldExtend: true};
            } else {
              if (props.authentication.redirectUrl) {
                const urlToRedirect = props.authentication.redirectUrl;
                goToPage(urlToRedirect);
              } else {
                goToPage(Config.lobbyUrl);
              }
            }
          }
        }
        return {isSuccess: true};
       } 
       else if (isGenericLogin) {
        const urlToRedirect = props.authentication.redirectUrl;
        await goToPage(urlToRedirect, true);
        return {isSuccess: true};
       }
      else
      {
        moveStage(loginStep.GENERALERROR);
        await props.saveToHistory(loginStep.GENERALERROR);
      }
    } else {
      if (resOtp.codeError == 58 || resOtp.codeError == 42 || resOtp.codeError == 99 || resOtp.codeError == 39) {
        props.setContinueToSite(false);
        moveStage(loginStep.ERROR);
        await props.saveToHistory(loginStep.ERROR);
      } else if (resOtp.codeError == 750) {
        props.setContinueToSite(false);
        moveStage(loginStep.GENERALERROR);
        await props.saveToHistory(loginStep.GENERALERROR);
      } else if (resOtp.codeError == 1003) {
        setLoading(false);

        return {isSuccess: false, codeError: 1003};
      } else {
        setLoading(false);

        return resOtp;
      }
    }
  }

  async function handleOtpStep3(val) {
    const resId = await OtpStep3Connect({
      phoneNumber: props.authentication.loginData.userDetails.contactNumber,
      idNumber: val,
      scope: lobbyToSend,
      code: '',
      otpOrigin: otpOrigin.LOGIN,
      originProcess: props.authentication.redirectUrl,
    });
    if (resId) {
      if (resId.isSuccess) {
        if (resId.needsCode) {
          setId(val);
          moveStage(loginStep.CODE);
          await props.saveToHistory(loginStep.CODE);
        } else {
          if (
            props.authentication.redirectUrl &&
            props.authentication.shouldContinueToSite != null &&
            props.authentication.shouldContinueToSite == true
          ) {
            const urlToRedirect = props.authentication.redirectUrl;
            goToPage(urlToRedirect);
          } else {
            //refer to correct lobby once it is done
            switch (lobbyToSend) {
              case lobbySelection.PRIVATE:
                if (props.authentication.redirectUrl) {
                  goToPage(props.authentication.redirectUrl);
                } else {
                  setBusinessTab(0);
                  goToPage(Config.lobbyUrl);
                }
                break;
              case lobbySelection.BUSINESS:
                if (props.authentication.redirectUrl) {
                  goToPage(props.authentication.redirectUrl);
                } else {
                  setBusinessTab(1);
                  goToPage(Config.businessLobbyUrl);
                }
                break;
            }
          }
        }
        return true;
      } else {
        setLoading(false);
        if (resId.codeError == 750) {
          moveStage(loginStep.GENERALERROR);
          props.setContinueToSite(false);
          await props.saveToHistory(loginStep.GENERALERROR);
        }
        return false;
      }
    } else {
      setLoading(false);
      return false;
    }
  }

  const continueToNextStep = async (val, secVal = '') => {
    if (isNotOut) {
      await props.saveToHistory();
      setLoading(true);
      try {
        switch (props.loginStage) {
          case loginStep.PHONE:
            setResetProcess(false);
            let resPhone = null;
            
            let reqObj = {
              isExtended: false,
              otpOrigin: otpOrigin.LOGIN,
              originProcess: props.authentication.redirectUrl,
            };
            if(isGenericLogin){
              reqObj.loginType = loginType;
              reqObj.genericFields = val;
            }else{
              reqObj.phoneNumber = val;
            }

              resPhone = await props.createOtpLoginStep1(reqObj);
          
            if (resPhone.payload.Body?.isSuccess) {
              //if the phone is correct, and recognized then it will send the OTP
              if (resPhone.payload.Body.resultMessage === 'OTP_RESTRICT_CODE_REQUIRE') {
                setCode(true);
              } else {
                setCode(false);
              }
              if (resPhone.payload.Body.extra.showTerms) {
                setTerms(true);
              }
              setTicket(resPhone.payload.Body.message);
              setPhone(resPhone.payload.Body?.extra?.contactNumber);

              moveStage(loginStep.OTP);
              await props.saveToHistory(loginStep.OTP);
            } else {
              resetStep2();
              AuthenticationProvider.clearAuthenticationData();
              moveStage(loginStep.ERROR);
              await props.saveToHistory(loginStep.ERROR);
            }

            break;
          case loginStep.OTP:
            const otpReturnedVal = await handleOtpSend2(val, secVal);
            return otpReturnedVal;

          case loginStep.ID:
            const idReturnedVal = await handleOtpStep3(val);
            return idReturnedVal;

          case loginStep.CODE:
            //refer to correct lobby once it is done
            const resCode = await OtpStep3Connect({
              phoneNumber: props.authentication.loginData.userDetails.contactNumber,
              idNumber: idUsed,
              scope: lobbyToSend,
              code: val,
              otpOrigin: otpOrigin.LOGIN,
              originProcess: props.authentication.redirectUrl,
            });
            if (resCode.loginData?.isFullAuthenticated) {
              if (props.authentication.redirectUrl) {
                const urlToRedirect = props.authentication.redirectUrl;
                goToPage(urlToRedirect);
              } else {
                switch (lobbyToSend) {
                  case lobbySelection.PRIVATE:
                    setBusinessTab(0);
                    goToPage(Config.lobbyUrl);
                    break;
                  case lobbySelection.BUSINESS:
                    setBusinessTab(1);
                    goToPage(Config.businessLobbyUrl);
                    break;
                }
              }
            } else {
              setLoading(false);
              return false;
            }

            break;
          case loginStep.SELECTLOBBY:
            //refer to correct lobby once it is done
            setLobby(val);
            switch (val) {
              case lobbySelection.PRIVATE:
                setBusinessTab(0);
                if (props.authentication.loginData.isFullAuthenticated) {
                  if (props.authentication.redirectUrl) {
                    const urlToRedirect = props.authentication.redirectUrl;
                    goToPage(urlToRedirect);
                  } else {
                    goToPage(Config.lobbyUrl);
                  }
                } else {
                  if (tooManyCodes) {
                    moveStage(loginStep.ID);
                    await props.saveToHistory(loginStep.ID);
                  } else if (
                    !props.authentication.loginData.userDetails.RoleList.some((r) => r.includes(rolesKeys.PRIVATE)) &&
                    props.authentication.loginData.userDetails.RoleList.some((r) => r.includes(rolesKeys.SUBSCRIBER)) &&
                    isOtherContact
                  ) {
                    //if not private contact and is cellular, but is a contact
                    moveStage(loginStep.SELECTPRIVATE);
                    await props.saveToHistory(loginStep.SELECTPRIVATE);
                  } else {
                    if (moreThanOneId) {
                      moveStage(loginStep.ID);
                      await props.saveToHistory(loginStep.ID);
                    } else {
                      if (props.authentication.redirectUrl) {
                        const urlToRedirect = props.authentication.redirectUrl;
                        goToPage(urlToRedirect);
                      } else {
                        setBusinessTab(0);
                        goToPage(Config.lobbyUrl);
                      }
                    }
                  }
                }
                break;
              case lobbySelection.BUSINESS:
                if (!props.authentication.loginData.isFullAuthenticated) {
                  setBusinessTab(1);
                  moveStage(loginStep.ID);
                  await props.saveToHistory(loginStep.ID);
                } else {
                  if (props.authentication.redirectUrl) {
                    const urlToRedirect = props.authentication.redirectUrl;
                    goToPage(urlToRedirect);
                  } else {
                    setBusinessTab(1);
                    goToPage(Config.businessLobbyUrl);
                  }
                }

                break;
            }
            break;
          case loginStep.SELECTPRIVATE:
            switch (val) {
              case rolesKeys.SUBSCRIBER:
                if (props.authentication.redirectUrl) {
                  const urlToRedirect = props.authentication.redirectUrl;
                  goToPage(urlToRedirect);
                } else {
                  goToPage(Config.lobbyUrl);
                }
                break;
              case rolesKeys.PRIVATE:
                moveStage(loginStep.ID);
                await props.saveToHistory(loginStep.ID);
                break;
            }
            break;
        }
      } catch {
        resetStep2();
        AuthenticationProvider.clearAuthenticationData();
        moveStage(loginStep.GENERALERROR);
        await props.saveToHistory(loginStep.GENERALERROR);
      }
      //setLoading(false);
    }
  };

  const continueToNextStepFull = async (val, secVal = '') => {
    if (isNotOut) {
      await props.saveToHistory();
      setLoading(true);
      try {
        switch (props.loginStage) {
          case loginStep.PHONE:
            props.resetLoginData();
            AuthenticationProvider.clearAuthenticationData(); //Reset auth in case of login from full
            setResetProcess(false);
            let resPhone = await props.createFullLoginStep1({...val, digits: '', originProcess: props.authentication.redirectUrl, loginType: loginType});
            if (resPhone.payload.Body?.isSuccess) {
              //if the phone is correct, and recognized then it will send the OTP
              switch (parseInt(resPhone.payload.Body.codeError)) {
                case 32:
                  setPhone(val.phoneNumber);
                  setId(val.idNumber);
                  moveStage(loginStep.DIGITS);
                  await props.saveToHistory(loginStep.DIGITS);
                  break;
                case 33:
                  setPhone(val.phoneNumber);
                  setId(val.idNumber);
                  if (resPhone.payload.Body.extra?.paymentType === 'PP') {
                    moveStage(loginStep.PAYPAL_EMAIL);
                    await props.saveToHistory(loginStep.PAYPAL_EMAIL);
                  } else {
                    moveStage(loginStep.DIGITS);
                    await props.saveToHistory(loginStep.DIGITS);
                  }
                  break;
                case 0:
                case 30:
                case 71:
                case 75:
                case 31:
                  if (resPhone.payload.Body.extra.showTerms) {
                    setTerms(true);
                  } else {
                    setTerms(false);
                  }
                  if (parseInt(resPhone.payload.Body.codeError) == 31 || parseInt(resPhone.payload.Body.codeError) == 75) {
                    setCode(true);
                  } else {
                    setCode(false);
                  }
                  if (parseInt(resPhone.payload.Body.codeError) == 71 || parseInt(resPhone.payload.Body.codeError) == 75) {
                    setMail(resPhone.payload.Body.extra.customerEmail);
                  }
                  if (resPhone.payload.Body.extra?.isVoice) {
                    setVoice(true);
                  } else {
                    setVoice(false);
                  }
                  setTicket(resPhone.payload.Body.message);
                  setPhone(val.phoneNumber);
                  setId(val.idNumber);
                  moveStage(loginStep.OTP);
                  await props.saveToHistory(loginStep.OTP);
                  break;
                default:
                  return false;
              }
            } else {
              if (parseInt(resPhone.payload.Body.codeError) == 50) {
                props.setContinueToSite(false);
                moveStage(loginStep.NOPRIMARYERROR);
                await props.saveToHistory(loginStep.NOPRIMARYERROR);
              } else if (parseInt(resPhone.payload.Body.codeError) == 58) {
                props.setContinueToSite(false);
                moveStage(loginStep.TALKMANERROR);
                await props.saveToHistory(loginStep.TALKMANERROR);
              } else {
                resetStep2();
                AuthenticationProvider.clearAuthenticationData();
                moveStage(loginStep.ERROR);
                await props.saveToHistory(loginStep.ERROR);
              }
            }

            break;
          case loginStep.DIGITS:
            let resDigits = await props.createFullLoginStep1({
              phoneNumber: phoneUsed,
              idNumber: idUsed,
              digits: val,
              originProcess: props.authentication.redirectUrl,
              loginType: loginType,
            });

            if (resDigits.payload?.Body?.isSuccess) {
              //if the phone is correct, and recognized then it will send the OTP
              switch (parseInt(resDigits.payload.Body.codeError)) {
                case 0:
                case 30:
                case 71:
                case 75:
                case 31:
                  setDigits(val);
                  if (resDigits.payload.Body.extra.showTerms) {
                    setTerms(true);
                  } else {
                    setTerms(false);
                  }
                  if (parseInt(resDigits.payload.Body.codeError) == 31 || parseInt(resDigits.payload.Body.codeError) == 75) {
                    setCode(true);
                  } else {
                    setCode(false);
                  }
                  if (parseInt(resDigits.payload.Body.codeError) == 71 || parseInt(resDigits.payload.Body.codeError) == 75) {
                    setMail(resDigits.payload.Body.extra.customerEmail);
                    if (!resDigits.payload.Body.extra.customerEmail) {
                      setPhoneChange(true);
                      setMail(resDigits.payload.Body.extra.contactNumber);
                    }
                  } else if (resDigits.payload.Body.extra.contactNumber != phoneUsed) {
                    setPhoneChange(true);
                    setMail(resDigits.payload.Body.extra.contactNumber);
                  }
                  setTicket(resDigits.payload.Body.message);
                  moveStage(loginStep.OTP);
                  await props.saveToHistory(loginStep.OTP);
                  break;
                default: {
                  setLoading(false);

                  return false;
                }
              }
            } else {
              setLoading(false);

              return false;
            }
            break;
          case loginStep.PAYPAL_EMAIL:
            let resPaypalEmail = await props.createFullLoginStep1({
              phoneNumber: phoneUsed,
              idNumber: idUsed,
              customerEmail: val,
              originProcess: props.authentication.redirectUrl,
              loginType: loginType,
            });

            if (resPaypalEmail.payload?.Body?.isSuccess) {
              //if the phone is correct, and recognized then it will send the OTP
              switch (parseInt(resPaypalEmail.payload.Body.codeError)) {
                case 0:
                case 30:
                case 71:
                case 75:
                case 31:
                  setDigits(val);
                  if (resPaypalEmail.payload.Body.extra.showTerms) {
                    setTerms(true);
                  } else {
                    setTerms(false);
                  }
                  if (parseInt(resPaypalEmail.payload.Body.codeError) == 31 || parseInt(resPaypalEmail.payload.Body.codeError) == 75) {
                    setCode(true);
                  } else {
                    setCode(false);
                  }
                  if (parseInt(resPaypalEmail.payload.Body.codeError) == 71 || parseInt(resPaypalEmail.payload.Body.codeError) == 75) {
                    setMail(resPaypalEmail.payload.Body.extra.customerEmail);
                    if (!resPaypalEmail.payload.Body.extra.customerEmail) {
                      setPhoneChange(true);
                      setMail(resPaypalEmail.payload.Body.extra.contactNumber);
                    }
                  } else if (resPaypalEmail.payload.Body.extra.contactNumber != phoneUsed) {
                    setPhoneChange(true);
                    setMail(resPaypalEmail.payload.Body.extra.contactNumber);
                  }
                  setTicket(resPaypalEmail.payload.Body.message);
                  moveStage(loginStep.OTP);
                  await props.saveToHistory(loginStep.OTP);
                  break;
                default: {
                  setLoading(false);

                  return false;
                }
              }
            } else {
              setLoading(false);

              return false;
            }
            break;
          case loginStep.OTP:
            let resOtp = await OtpStep2ConnectFull(val, secVal);
            const isSuccess = resOtp.isSuccess;
            if (isSuccess) {
              if (props.authentication.redirectUrl) {
                const urlToRedirect = props.authentication.redirectUrl;
                goToPage(urlToRedirect);
              } else {
                if (props.isBusinessTab && props.isBusinessTab == 1) {
                  setBusinessTab(1);
                  goToPage(Config.businessLobbyUrl);
                } else {
                  setBusinessTab(0);
                  goToPage(Config.lobbyUrl);
                }
              }
              return {isSuccess: true};
            } else {
              let codeGiven = parseInt(resOtp.codeError);
              if (codeGiven == 58 || codeGiven == 42 || codeGiven == 99 || codeGiven == 39) {
                props.setContinueToSite(false);
                moveStage(loginStep.ERROR);
                await props.saveToHistory(loginStep.ERROR);
              } else if (codeGiven == 750) {
                props.setContinueToSite(false);
                moveStage(loginStep.GENERALERROR);
                await props.saveToHistory(loginStep.GENERALERROR);
              } else if (codeGiven == 1003) {
                //otp expired popup todo
                setLoading(false);

                return {isSuccess: false, codeError: 1003};
              } else if (codeGiven == 74) {
                setContactCli(resOtp.contactCli);
                setConsumerIds(resOtp.consumersId);
                setContactId(resOtp.contactId);

                setLoading(false);
                return {isSuccess: false, codeError: 74};
              } else if (codeGiven == 58) {
                props.setContinueToSite(false);
                moveStage(loginStep.TALKMANERROR);
                await props.saveToHistory(loginStep.TALKMANERROR);
              } else if (codeGiven == 1002) {
                //max otp todo
                setLoading(false);

                return {isSuccess: false, codeError: 1002};
              } else {
                setLoading(false);

                return resOtp;
              }
            }
            return resOtp;
        }
      } catch {
        resetStep2();
        AuthenticationProvider.clearAuthenticationData();
        moveStage(loginStep.GENERALERROR);
        await props.saveToHistory(loginStep.GENERALERROR);
      }
    }
    return {isSuccess: true};
    //setLoading(false);
  };

  const renderScreen = () => {
    let points = [20, 40, 60, 80, 100];
    switch (props.loginStage) {
      case loginStep.NOPRIMARYERROR:
        return <NoPrimaryScreen stage={props.loginStage} onclick={continueToNextStep} />;
      case loginStep.TALKMANERROR:
        return <TalkmanScreen stage={props.loginStage} onclick={continueToNextStep} />;
      case loginStep.GENERALERROR:
        return <GeneralErrorScreen isFull={isFullLoginProcess} stage={props.loginStage} onclick={continueToNextStep} />;
      case loginStep.ERROR:
        return <ErrorScreen isFull={isFullLoginProcess} stage={props.loginStage} onclick={continueToNextStep} />;
      case loginStep.PHONE:
        if (isGenericLogin) {
          return (
            <GenericParamsInsert
              genericData={LoginFieldsByType[loginType]}  
              templateIcon={templateStyle.iconUrl}
              specialTitle={templateStyle.title}
              specialText={templateStyle.secondaryText}
              isReset={isResetProcess}
              stage={props.loginStage}
              setGenericValues={setGenericValues}
              onclick={(values) =>
                continueToNextStep({...values})
              }
            />
          );
        } else if (isFullLoginProcess) {
          return (
            <PhoneInsertFullLogin
              templateIcon={templateStyle.iconUrl}
              specialTitle={templateStyle.title}
              specialText={templateStyle.secondaryText}
              isReset={isResetProcess}
              stage={props.loginStage}
              onclick={continueToNextStepFull}
            />
          );
        } else {
          return (
            <PhoneInsert
              templateIcon={templateStyle.iconUrl}
              specialTitle={templateStyle.title}
              specialText={templateStyle.secondaryText}
              isReset={isResetProcess}
              stage={props.loginStage}
              onclick={continueToNextStep}
            />
          );
        }
      case loginStep.OTP:
        if (isFullLoginProcess) {
          if (mailUsed) {
            return (
              <MailOTPInsert
                stage={props.loginStage}
                onclick={continueToNextStepFull}
                termsLink={`${Config.epiBaseUrl + props.iContent?.termsAndAgreement?.value}`}
                showTerms={showTerms}
                displayCode={codeNeeded}
                sendAgain={sendOtpAgain}
                typePhone={isPhoneChange}
                phoneUsed={phoneUsed}
                contactAction={ChangeContact}
                contactVal={mailUsed}
                resetProcess={resetAndGoToPhone}
              />
            );
          } else {
            return (
              <OTPInsert
                isFull={true}
                stage={props.loginStage}
                isVoice={isVoiceOtp}
                onclick={continueToNextStepFull}
                termsLink={`${Config.epiBaseUrl + props.iContent?.termsAndAgreement?.value}`}
                showTerms={showTerms}
                displayCode={codeNeeded}
                sendAgain={sendOtpAgain}
                resetProcess={resetAndGoToPhone}
                contactVal={phoneUsed}
              />
            );
          }
        } else {
          return (
            <OTPInsert
              stage={props.loginStage}
              onclick={continueToNextStep}
              termsLink={`${Config.epiBaseUrl + props.iContent?.termsAndAgreement?.value}`}
              showTerms={showTerms}
              displayCode={codeNeeded}
              sendAgain={sendOtpAgain}
              finishExtended={finishExtended}
              resetProcess={resetAndGoToPhone}
              contactVal={phoneUsed}
            />
          );
        }
      case loginStep.ID:
        return (
          <IdInsert
            stage={props.loginStage}
            selectedLobby={lobbyToSend}
            loginData={props.authentication.loginData}
            onclick={continueToNextStep}
          />
        );
      case loginStep.CODE:
        return <CodeInsert stage={props.loginStage} onclick={continueToNextStep} />;
      case loginStep.SELECTLOBBY:
        return <ChooseLobby stage={props.loginStage} onclick={continueToNextStep} />;
      case loginStep.SELECTPRIVATE:
        return <ChoosePrivate stage={props.loginStage} onclick={continueToNextStep} />;
      case loginStep.DIGITS:
        return <FourDigitEntry stage={props.loginStage} onclick={continueToNextStepFull} />;
      case loginStep.PAYPAL_EMAIL:
        return <PaypalEmailEntry stage={props.loginStage} onclick={continueToNextStepFull} />;
      default:
        return null;
    }
  };
  const style = templateStyle.backgroundUrl ? {backgroundImage: `url(${templateStyle.backgroundUrl})`} : null;
  console.log('style, ', style);
  const renderedScreen = renderScreen();
  const progressBarRender = renderProgressBar();
  return (
    <div className={`OTPLoginBlock ${isFullLoginProcess ? 'FullLoginOTP' : ''}`} style={style}>
      {isLoading && <Loader />}
      <Header {...props}>{progressBarRender}</Header>
      {renderedScreen}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    authentication: state.authentication,
    loginStage: state.authentication.loginStep,
    isBusinessTab: state.Header?.tabIndex,
  };
};

const mapDispatchToProps = {
  createOtpLoginStep1,
  createOtpLoginStep02,
  createOtpLoginStep3,
  resendOtpStep1,
  saveToHistory,
  saveDumbLogin,
  setLoginStage,
  resetAuth,
  resetLoginData,
  setContinueToSite,
  setRedirectUrl,
  showAppLoader,
  hideAppLoader,
  setOtpError,
  setRestrictedCodeError,
  createFullLoginStep1,
  changeContactLogin,
  setLoginTemplate,
  forceExtendedOtp,
  setTabIndex,
  reAuthenticateThunk,
  clearHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(OTPLogin);
